import * as d3 from 'd3'
export default {
  /*
    app_bar_Hoz_Std
  */
  methods: {

    app_bars_Hoz_Std(selection, idx, data, obj) {

      let arrCols = new Array(3)

      obj.cols.forEach((d,i)=> {

        arrCols = JSON.parse(JSON.stringify(d))

        if(obj.chart == 'quantity') {
          arrCols.code = d.code[1]
          arrCols.filter = d.filter[1]
        } else if(obj.chart == 'progress') {
          arrCols.code = d.code[0]
          arrCols.filter = d.filter[0]
        }

        let value = obj.totalRef ? (data[arrCols.code] / data[obj.totalRef]) * 100 : data[arrCols.code]
        let proLen = d.width ? (value/100) * d.width : (value/100) * obj.bar.width

        let title = selection
        .append('g')
        .attr('transform', `translate(${d.x}, ${d.y})`)

        title // Title
        .append('text')
        .attr('y', (d.tSize ? d.tSize : obj.title.tSize)*0.35)
        .attr('font-size', d.tSize ? d.tSize : obj.title.tSize)
        .attr('fill', d.tColor ? d.tColor : obj.title.tColor)
        .text(d.name)

        // Sub-Title
        if(obj.sub && d.sub) {
          title
          .append('text')
          .attr('x', obj.sub.x) .attr('y', obj.sub.y)
          .attr('font-size', d.sSize ? d.sSize : obj.sub.sSize)
          .attr('fill', d.sColor ? d.sColor : obj.sub.sColor)
          .text(d.sub)
        }

        let pos = {x: 0, y:0}
        switch(obj.position) {
          case 'updown':
            pos.x = d.x
            pos.y = d.y + obj.space
          break
          case 'space':
            pos.x = d.x + obj.space
            pos.y = d.height ? d.y - (d.height/2) : d.y - (obj.bar.height/2)
          break
        }

        let barChart = selection
        .append('g')
        .attr('transform', `translate(${pos.x}, ${pos.y})`)
        .attr('cursor', 'default')

        barChart // barChart background
        .append('rect')
        .attr('rx', d.radius ? d.radius : obj.bar.radius)
        .attr('width', d.width ? d.width : obj.bar.width)
        .attr('height', d.height ? d.height : obj.bar.height)
        .attr('fill', '#E0E0DF')
        .attr('opacity', .4)

        barChart // Prog barChart
        .append('rect')
        .attr('rx', d.radius ? d.radius : obj.radius)
        .attr('width', proLen)
        .attr('height', d.height ? d.height : obj.bar.height)
        .attr('fill', ()=> {
          let color = d.bColor ? d.bColor : obj.bar.bColor
          color = color.charAt(0) == '#' ? color : `url(#${this.localId}_${color})`
          return color
        })
        .attr('opacity', d.opacity ? d.opacity : obj.bar.opacity)


        barChart // Prog Value
        .append('text')
        .attr('x', ()=> {
          let x_ = 2
          if(obj.alignment == 'left') x_ =  2
          if(obj.alignment == 'prog') x_ = value < 70 ? proLen + 2 : proLen - 2
          return x_
        })
        .attr('y', (d.height ? d.height/2 -.5 : obj.bar.height/2) + (d.vSize ? d.vSize : obj.value.vSize)*0.35)
        .attr('font-size', d.vSize ? d.vSize : obj.value.vSize)
        .attr('fill', d.vColor ? d.vColor : obj.value.vColor)
        .attr('text-anchor', ()=> {
          let align_ = 'start'
          if(obj.alignment == 'left') align_ =  'start'
          if(obj.alignment == 'prog') align_ = value < 70 ? 'start' : 'end'
          return align_
        })
        .text((obj.chart == 'quantity') ? data[arrCols.code] : this.app_toFixed(value, obj.value.fixed, d.fixed) + '%')
        .call(this.app_Link, data, arrCols)

        // ### quantity ###
        if(obj.chart == 'quantity') {

          arrCols = JSON.parse(JSON.stringify(d))
          arrCols.code = d.code[0]
          arrCols.filter = d.filter[0]

          barChart // Total
          .append('text')
          .attr('x', -2)
          .attr('y', (d.height ? d.height/2 -.5 : obj.bar.height/2) + (d.vSize ? d.vSize : obj.value.vSize)*0.35)
          .attr('font-size', d.vSize ? d.vSize : obj.value.vSize)
          .attr('fill', d.vColor ? d.vColor : obj.value.vColor)
          .attr('text-anchor', 'end')
          .text(data[arrCols.code])
          .call(this.app_Link, data, arrCols)

          arrCols = JSON.parse(JSON.stringify(d))
          arrCols.code = d.code[2]
          arrCols.filter = d.filter[2]

          barChart // Remain
          .append('text')
          .attr('x', d.width ? d.width + 2 : obj.bar.width + 2)
          .attr('y', (d.height ? d.height/2 -.5 : obj.bar.height/2) + (d.vSize ? d.vSize : obj.value.vSize)*0.35)
          .attr('font-size', d.vSize ? d.vSize : obj.value.vSize)
          .attr('fill', d.vColor ? d.vColor : obj.value.vColor)
          .attr('text-anchor', 'start')
          .text(data[arrCols.code])
          .call(this.app_Link, data, arrCols)
        }

      })
    },

  
    
  }
}
